export const customerDetailsOverviewOptions = [
  { value: "Send Reminder", key: "sendRemainder" },
  { value: "View Details", key: "viewDetails" },
];
